import { Suspense, useEffect, useMemo, useRef, useState } from "react";
import "./SideBarV2.css";
import notificationsound from '../../assets/popp.mp3'
import { linkedhashmap, linkedhashmapdata, storeAllCategoriesData, storeLeafCategories } from "./sidebarutility/linkedhashmap";
import { getSideBarDetails } from "./sidebarutility/getsidebardetails";
import Hexapi from "../../utility/HexAPI/Hexapi";
import { getAllImageStore, setImageEntry } from "../../utility/indexedDBHelper";
import TutorialModal from "../../components/tutorialmodal/Tutorialmodal";
import { fetchImagesIfVersionChanged } from "./sidebarutility/fetchImagesIfVersionChanged";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import HelpModal from "../../components/HelpModal/Helpmodal";
import Suggestionbugmodal from "../../components/SuggestionBugReport/Suggestionbugmodal";
import Dashboardheader from "./Dashboardheader";
import Maindashboard from "./Maindashboard";
import { fetchUsers } from "../../Redux/userthunk/userThunk";
import { useDispatch, useSelector } from "react-redux";
import { setTrackHRDataCategory } from "../../Redux/features/categoryslice";
import backImg from '../../assets/go-back.png'
import PageLoader from "../PageLoader";
import { showConfirm } from "../../utility/showconfirm";
import { setUserData } from "../../Redux/features/UserDataslice";
import buildNumber from '../../buildNumber.json'
import config from "../../colors/config";
import IframePage from "./IframePage";
import axios from "axios";
import { secureGet, secureRemove, secureSet } from "../../utility/secureStorage";
import Loader from "../../components/loader/Loader";
import { Modal } from "react-bootstrap";
import { useAliveController } from "react-activation";


const SideBar = () => {
    const lastFetchTime = useRef(0);
    const { clear } = useAliveController();
    const isFetchingUsers = useRef(false);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const colors = config?.colors;
    const audioRef = useRef(null)
    const intervalID = useRef(null);
    const [usercode, setusercode] = useState(localStorage.getItem("usercode"))
    const [userName, setUserName] = useState(null);
    const [userFirstName, setUserFirstName] = useState("");
    const [showWidth, setShowWidth] = useState("280px");
    const [Display, setDisplay] = useState("block");
    const [navIcon, setNavIcon] = useState("");
    const [activeLink, setActiveLink] = useState("Home");
    const [isOpenHelpModal, setIsOpenHelpModal] = useState(false);
    const [isOpenBugModal, setIsOpenBugModal] = useState(false);
    const [suggestionValue, setSuggestionValue] = useState("");
    const [isBugSend, setIsBugSend] = useState(true);
    const [countnav, setCountnav] = useState([]);
    const [sessiondata, setSessiondata] = useState(null);
    const [AIChatbotLink, setAIChatbotLink] = useState(null);
    const [novalink, setNovalink] = useState(false);
    const [isLoadingshow, setIsLoadingshow] = useState(false);
    const [youtubevideo, setYoutubevideo] = useState(false);
    const [isNavtrue, setisNavtrue] = useState(false)
    const [istutorialinfo, setistutorialinfo] = useState(null)
    const [fade, setFade] = useState(false);
    const [isManuallyToggled, setIsManuallyToggled] = useState(false);
    const [chatbotLoaded, setChatbotLoaded] = useState(false);
    const [subscriptionurl, setsubscriptionurl] = useState(null)
    const [buildNumberbackend, setbuildNumber] = useState(undefined)
    const [manualToggleValue, setManualToggleValue] = useState(false)
    let user = useSelector(state => state?.users?.data?.[""]?.[0]);

    let userid = user?.empid ? user?.empid : null
    const [clientData, setclientData] = useState(null)
    const { activeCategoryDataArr, CategoryDataArr } = useSelector(state => state.trackhrcategory);
    const location = useLocation()
    // const sideBarDetails = getSideBarDetails(countnav, sessiondata, userid, userFirstName);
    const isMySubscription = location.pathname === "/mysubscriptions";
    const isChatbot = location.pathname.includes("/novachatbot");
    const internalurl = useSelector(state => state?.trackhrdata?.internalurl)
    const apipath = useSelector(state => state?.trackhrdata?.apipathurl)
    const [clientDetail] = useState(navigator.userAgent);
    const [isLoading, setIsLoading] = useState(false);
    const [chatbotURL, setChatbotURL] = useState(null);
    const [isloadingque, setisloadingque] = useState(false)
    const [searchchatbot, setsearchchatbot] = useState(null)
    const rawConfig = useSelector((state) => state?.rawconfig?.rawconfigdata);
    const [sideBarDetails, setSideBarDetails] = useState([]);

    useEffect(() => {
        const details = getSideBarDetails(countnav, sessiondata, rawConfig);
        setSideBarDetails(details);
    }, [rawConfig, countnav, sessiondata]);
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data?.type == "DEFQUES") {
                const question = event.data;
                console.log(question, "question")
                setsearchchatbot(question?.data);
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);
    useEffect(() => {

        setsubscriptionurl(internalurl)
    }, [internalurl])
    useEffect(() => {
        if (isChatbot || isMySubscription) setChatbotLoaded(true);
    }, [isChatbot, isMySubscription]);


    useEffect(() => {
        if (apipath) {
            console.log("apipath")
            projectversion()
        }
    }, [apipath])

    useEffect(() => {
        return () => {
            if (intervalID.current) {
                clearInterval(intervalID.current);
                intervalID.current = null;
            }
        };
    }, []);

    const showLogoutConfirm = async () => {
        const result = await showConfirm({
            content: "Are you sure you want to logout?",
            hideCancel: false,
            okText: "Yes, Proceed to Log Out",
            cancelText: "Cancel"
        })

        if (!usercode || !clientDetail || !userid) return;
        if (result) {
            const obj = {
                query: `HRApp_Web_Proc_User_Logout '{0}','{1}','{2}'`,
                queryArr: [`${usercode}`, `${clientDetail}`, `${userid}`]
            }

            setIsLoading(true);
            Hexapi(obj).then(async (resp) => {
                const jsondata = resp;
                if (jsondata?.[""]?.[0]?.command == 1) {
                    user = null
                    userid = null
                    setusercode(null)
                    if (usercode && usercode !== "undefined") {
                        setChatbotLoaded(false);
                        secureRemove("rawconfig")
                        setsearchchatbot(null)
                        clear();
                        setIsManuallyToggled(false);
                        localStorage.removeItem("usercode")
                        localStorage.removeItem("SessionID")
                        localStorage.clear()
                        if (intervalID.current) {
                            clearInterval(intervalID.current)
                            intervalID.current = null
                        }
                        const imageStore = await getAllImageStore();
                        const deletePromises = Object.keys(imageStore).map(id =>
                            setImageEntry({ ...imageStore[id], version: "-1" })
                        );
                        await Promise.all(deletePromises);
                        setSessiondata(null);
                        setusercode(null)
                        setUserName("");

                        setUserFirstName("");
                        setActiveLink("");
                        setNavIcon("");
                        setCountnav([]);
                        setAIChatbotLink(null);
                        navigate("/login", { replace: true });
                        dispatch({ type: "RESET_STORE" });

                    }
                }
            }).catch((err) => {
                console.error("Logout failed", err);
            }).finally(() => {
                setIsLoading(false);
            })
        }
    }
    useEffect(() => {
        if (location.pathname.includes("profile") || location.pathname.includes("tickets") ) {
            setActiveLink("");
            setNavIcon("");
            setisNavtrue(false);
        }

    }, [location.pathname, location.search]);


    useEffect(() => {

        if (isManuallyToggled) return;

        if (location.pathname === "/home" || location.pathname === "/") {
            showSidebar();
            setChatbotLoaded(false)
        } else {
            hideSidebar();
        }

    }, [location.pathname, isManuallyToggled]);
    useEffect(() => {
        setFade(true);

        const timer = setTimeout(() => {
            setFade(false);
        }, 200);

        return () => clearTimeout(timer);
    }, [navIcon]);
    useEffect(() => {
        const cleanPath = location.pathname
            .toLowerCase()
            .replace(/\s+/g, "")
            .replace(/-/g, "");

        const routeMap = {
            addactivity: "addactivity",
            editactivity: "addactivity",
            openticket: "addticket",
            broadcasts: "addbroadcast",
            kpiadd: "addkpis",
            approvermanagement: "approvermanagement",
            payroll: "payroll"
        };

        const matchedKey = Object.keys(routeMap).find(key =>
            cleanPath.includes(key)
        );
        setistutorialinfo(matchedKey ? routeMap[matchedKey] : null);

    }, [location.pathname]);

    const projectversion = async () => {
        const url = `${apipath}projectversion.php`;
        console.log(url, "url")
        try {
            const { data } = await axios.get(url);
            console.log(data, 'data')
            setbuildNumber(data)

        } catch (error) {
            console.error(error);
        }
    }


    useEffect(() => {
        if (location.pathname.includes("/novachatbot")) {
            setActiveLink("")
            setNavIcon("")
        }

        if (!sideBarDetails || sideBarDetails.length == 0) return;
        const pathname = location.pathname.toLowerCase();
        const search = location.search.toLowerCase();

        console.log(pathname, "pathname")
        let decodedQuery = "";
        if (pathname === "/") {
            const homeRoute = sideBarDetails.find(
                route => route?.targetPage?.toLowerCase() === "home"
            );

            setActiveLink(homeRoute?.name || "Home");
            setNavIcon(homeRoute?.icon || "");
        }

        const hasQuery = search && search.includes("?");


        if (hasQuery) {
            setisNavtrue(true);
            setNavIcon(backImg);
        } else {
            setisNavtrue(false);
        }

        const reportRoutes = [
            "dailywork",
            "leaderboard",
            "taskcoating",
            "tasktiming",
            "dynamicreport"
        ];

        const isReportPage = reportRoutes.some(route =>
            pathname.includes(route)
        );

        if (isReportPage) {
            const reportRoute = sideBarDetails.find(
                route => route?.name?.toLowerCase() === "reports"
            );

            setActiveLink("Reports");
            setNavIcon(reportRoute?.icon || "");
            return;
        }

        if (hasQuery) return;

        const current = sideBarDetails.find(route => {
            if (!route?.targetPage) return false;

            const target = route.targetPage.toLowerCase();

            return (
                pathname.includes(target) ||
                decodedQuery.includes(target)
            );
        });

        if (current) {
            setisNavtrue(false)
            setActiveLink(current.name);
            setNavIcon(current.icon || "");
        }

    }, [location.pathname, location.search, sideBarDetails]);

    useEffect(() => {
        const handleCustomEvent = (event) => {
            if (!event?.detail) return;
            console.log("calleedddddddddddddddd")
            const { header } = event.detail;
            console.log(header,"heeardrdd")
            setActiveLink(header);
            // setNavIcon(backImg);
            // setisNavtrue(true)
        };

        window.parent.document.addEventListener(
            "myCustomEvent",
            handleCustomEvent
        );

        return () => {
            window.parent.document.removeEventListener(
                "myCustomEvent",
                handleCustomEvent
            );
        };
    }, []);


    useEffect(() => {
        if (usercode) {
            dispatch(fetchUsers({ usercodeset: usercode, autologin: 1 }))
        }
    }, [usercode])


    const navcount = async () => {
        if (!userid && !localStorage.getItem("orgdbname") && !localStorage.getItem("usercode")) return;
        const obj = {
            query: `[HRApp_Droid_Proc_User_NavCount_GetData] @userid='{0}'`,
            queryArr: [`${userid}`],
        };
        const response = await Hexapi(obj, () => navcount(), 0, 0);
        console.log(response, "response")
        if (response && response.maininfo && response.maininfo[0]) {
            setCountnav(response?.maininfo)
        }
    }

    const fetchUserDetails = (isload = false) => {

        if (isload) {
            setIsLoadingshow(true)
        }
        return new Promise((resolveOuter, rejectOuter) => {
            if (usercode && userid && localStorage.getItem("orgdbname")) {
                const obj = {
                    query: `HRApp_Web_Proc_User_GetDetails @usercode='{0}', @userid='{1}'`,
                    queryArr: [`${usercode}`, `${userid}`]
                }
                Hexapi(obj).then(async (resp) => {
                    console.log(resp, "resp")
                    const respdata = resp[""][0];
                    setIsLoadingshow(false)

                    if (!respdata) {
                        // console.log(respdata,"")
                        showConfirm({
                            content: `${respdata}`,
                            hideCancel: true
                        })
                        return;
                    }

                    if (respdata && respdata?.command != "-1") {
                        const userData = {
                            ClientID: respdata.clientid,
                            CountryCode: respdata.countrycode,
                            EmailID: respdata.emailid,
                            PhoneNo: respdata.phoneno,
                            ShowSubscriptions: respdata.showsubscriptions,
                            ShowReferScreen: respdata.showreferscreen,
                            AIChatbotLink: respdata.aichatbotlink ? respdata.aichatbotlink : null,
                            ApiPath: respdata.apipath,
                            username: `${respdata.firstname} ${respdata.lastname}`
                        };

                        dispatch(setUserData({ userData: userData }))
                        setAIChatbotLink(respdata.aichatbotlink ? respdata.aichatbotlink : null)
                        setSessiondata(respdata)
                        setUserFirstName(respdata.firstname)
                        setUserName(`${respdata.firstname} ${respdata.lastname}`)

                        const phonenumber = `${respdata.countrycode}${respdata.phoneno}`;
                        const encryptedParams = btoa(`clientuniqueid=${respdata.clientid}&phoneno=${phonenumber}&emailid=${respdata.emailid}&countrycode=${respdata.countrycode}`);
                        setclientData(encryptedParams)
                        const imageStore = await getAllImageStore();
                        const sample = Object.values(imageStore)[0];

                        if (respdata?.orgdbname && Object.keys(imageStore).length > 0 && sample?.orgdbname && sample?.orgdbname != respdata?.orgdbname) {
                            const updatePromises = Object.keys(imageStore).map(id => {
                                const updatedEntry = {
                                    ...imageStore[id],
                                    version: "-1",
                                    orgdbname: respdata.orgdbname
                                };
                                return setImageEntry(updatedEntry);
                            });

                            await Promise.all(updatePromises);
                            localStorage.setItem("OrgPhotoVersion", "-1");
                        }

                        const updatedImageStore = await getAllImageStore();
                        const hasInvalidVersion = Object.values(updatedImageStore).some(entry => entry.version === "-1");
                        await fetchImagesIfVersionChanged(respdata.orgphotoversion, hasInvalidVersion)
                        resolveOuter();
                    } else {
                        setIsLoadingshow(false)
                        if (localStorage.getItem("usercode")) {
                            showConfirm({
                                content: `${(respdata && respdata.msg) && respdata.msg}`,
                                hideCancel: true
                            })
                                .then(() => {
                                    setusercode(null)
                                    setChatbotLoaded(false);
                                    localStorage.removeItem("usercode")
                                    localStorage.removeItem("SessionID")
                                    localStorage.clear()
                                    if (intervalID.current) {
                                        clearInterval(intervalID.current)
                                        intervalID.current = null
                                    }
                                    navigate("/login", { replace: true });
                                    dispatch({ type: "RESET_STORE" });
                                });
                        }

                    }
                })

            } else {
                navigate("/login", { replace: true });
            }
        });
    }

 useEffect(() => {
    window.parent.addEventListener("NEW_TICKET_EVENT", playNotification);  
    document.addEventListener("click", unlockAudio);
    return () => {
        window.parent.removeEventListener("NEW_TICKET_EVENT", playNotification);
        document.removeEventListener("click", unlockAudio);
    };
}, []);

    const unlockAudio = () => {
        if (audioRef.current) {
            audioRef.current
                .play()
                .then(() => {
                    audioRef.current.pause();
                    audioRef.current.currentTime = 0;

                })
                .catch((err) => console.log("Play blocked:", err));
        }
        document.removeEventListener("click", unlockAudio);
    };

    const playNotification = () => {
        if (audioRef.current) {
            audioRef.current
                .play()
                .catch((err) => console.log("Play failed:", err));
        }
    };


    useEffect(() => {
        const handleVisibilityChange = () => {
            console.log("Visibility:", document.visibilityState, Date.now());
        };

        window.addEventListener("focus", () => {
            console.log("Window Focus", Date.now());
        });

        window.addEventListener("blur", () => {
            console.log("Window Blur", Date.now());
        });

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
    useEffect(() => {
        if (!userid || !usercode) return;

        isFetchingUsers.current = false;

       const safeFetchUserDetails = async (force = false) => {
    if (isFetchingUsers.current) return;
    isFetchingUsers.current = true;

    try {
        await fetchUserDetails(force);
    } catch (err) {

        if (
            err?.code === "ERR_CANCELED" ||
            err?.message === "canceled" ||
            err?.name === "CanceledError"
        ) {
            console.warn("Background fetch cancelled");
            return;
        }
        console.error("fetchUserDetails error:", err);
    } finally {
        isFetchingUsers.current = false;
    }

        };

        const startInterval = () => {
            if (intervalID.current) {
                clearInterval(intervalID.current);
            }
            intervalID.current = setInterval(() => {
                safeFetchUserDetails(false);
            }, 30000);
        };

        const handleVisibilityChange = async () => {
            if (document.visibilityState === "visible") {
                const now = Date.now();

                if (now - lastFetchTime.current < 5000) {
                    return;
                }

                lastFetchTime.current = now;
                await safeFetchUserDetails(false);
                startInterval();
            } else {
                if (intervalID.current) {
                    clearInterval(intervalID.current);
                }
            }
        };
        safeFetchUserDetails(false);
        startInterval();
        document.addEventListener("visibilitychange", handleVisibilityChange);


        return () => {
            if (intervalID.current) {
                clearInterval(intervalID.current);
                intervalID.current = null;
            }

            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };

    }, [userid, usercode]);
    useEffect(() => {

        if (userid) {

            if (userid != null && localStorage.getItem("orgdbname")) {
                const obj = {
                    query: `[HRApp_Droid_Proc_Organisation_Category_GetListv2] @userid='{0}'`,
                    queryArr: [`${userid}`]
                }

                Hexapi(obj).then((resp) => {
console.log(resp,"respp")
                    const hierarchy = linkedhashmap(resp?.categories);
                    let finalActiveCategoryData = {};

                    hierarchy.forEach((node) => {
                        storeLeafCategories(node, finalActiveCategoryData);
                    });

                    const hierarchydata = linkedhashmapdata(resp?.categories);
                    let finalCategoryData = {};

                    hierarchydata.forEach((node) => {
                        storeAllCategoriesData(node, finalCategoryData);
                    })
console.log(finalCategoryData,"CategoryDataArr")
                    if (
                        (!activeCategoryDataArr || Object.keys(activeCategoryDataArr).length === 0) &&
                        (!CategoryDataArr || Object.keys(CategoryDataArr).length === 0)
                    ) {

                        dispatch(setTrackHRDataCategory({
                            activeCategoryDataArr: finalActiveCategoryData,
                            CategoryDataArr: finalCategoryData
                        }));
                    }

                });
            }

        }

    }, [userid])


    useEffect(() => {
        if (userid && usercode && localStorage.getItem("orgdbname")) {
            secureSet("item", userid)
            navcount();
            // fetchUserDetails(true);
        }
    }, [userid, usercode]);


    const hideSidebar = () => {
        setShowWidth("100px")
        setDisplay("none")
    }

    const showSidebar = () => {
        setShowWidth("280px")
        setDisplay("block")
    }

    useEffect(() => {
        if (user) {
            if (user?.command == 0) {
                showConfirm({
                    content: user.msg,
                    hideCancel: true,
                });
                // localStorage.removeItem("usercode");
                // navigate("/login", { replace: true });
                setChatbotLoaded(false);
                localStorage.clear()
                localStorage.removeItem("SessionID")
                localStorage.removeItem("usercode")
                if (intervalID.current) {
                    clearInterval(intervalID.current)
                    intervalID.current = null
                }
                setSessiondata(null);
                setusercode(null)
                setUserName("");
                setUserFirstName("");
                setActiveLink("");
                setNavIcon("");
                setCountnav([]);
                setAIChatbotLink(null);
                navigate("/login", { replace: true });
                dispatch({ type: "RESET_STORE" });
            }
        } else {

        }
    }, [user, navigate]);

    if (!userid) return <PageLoader />;

    return (
        <>
            {isLoading && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100vh",
                    background: "rgba(255,255,255,0.6)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999
                }}>
                    <Loader />
                </div>
            )}

            <div
                className="container-fluid"
                style={{ padding: "0px", overflow: "hidden", height: "100vh" }}
            >
                <audio ref={audioRef} src={notificationsound} preload="auto" />
                {
                    !isChatbot &&
                    <Dashboardheader setManualToggleValue={setManualToggleValue} setIsManuallyToggled={setIsManuallyToggled} fade={fade} istutorialinfo={istutorialinfo} isNavtrue={isNavtrue} userid={userid && userid} colors={colors} setIsOpenHelpModal={setIsOpenHelpModal} showWidth={showWidth} setYoutubevideo={setYoutubevideo} hideSidebar={hideSidebar} showSidebar={showSidebar} countnav={countnav} navIcon={navIcon} setNavIcon={setNavIcon} activeLink={activeLink} setActiveLink={setActiveLink} />
                }

                <div className="mainBox_Dashboard" style={{ overflow: "hidden", height: isChatbot && "100vh" }}>
                    <Maindashboard setManualToggleValue={setManualToggleValue} manualToggleValue={manualToggleValue} isChatbot={isChatbot} hideSidebar={hideSidebar} showSidebar={showSidebar} setsearchchatbot={setsearchchatbot} setChatbotLoaded={setChatbotLoaded} showLogoutConfirm={showLogoutConfirm} colors={colors} setIsManuallyToggled={setIsManuallyToggled} usercode={usercode} userid={userid} userName={userName} showWidth={showWidth} setIsOpenHelpModal={setIsOpenHelpModal} Display={Display} sideBarDetails={sideBarDetails} activeLink={activeLink} AIChatbotLink={AIChatbotLink} />
                    <div
                        className={novalink ? "chatWindow" : "Dashboard_content"}
                        id="contentBox"
                        style={{
                            height: isChatbot && "100vh",
                            width: `calc(100% - ${showWidth})`,
                            transition: "0.2s all",
                            background: "#f8f9fb",
                        }}
                    >
                        {isLoadingshow ? (
                            <PageLoader />
                        ) : (
                            <>
                                {
                                   (isMySubscription && chatbotLoaded) && (<div style={{ display: isMySubscription ? "block" : "none", height: "100%" }}>
                                        {
                                            (subscriptionurl && clientData) && <IframePage url={`${subscriptionurl}TrackHRPaymentGateway?${clientData}`} />
                                        }

                                    </div>)
                                }

                                {(chatbotLoaded && userid && AIChatbotLink) && (

                                    <div style={{ display: isChatbot ? "block" : "none", height: "100%" }}>
                                        <IframePage
                                            url={`${AIChatbotLink}?${btoa(
                                                `userid=${userid}&dbname=${localStorage.getItem("orgdbname")}${(searchchatbot) ? `&defques=${searchchatbot}` : ""
                                                }&projectversion=${"9"}`
                                            )}`}
                                        />
                                    </div>
                                )}

                                {!isMySubscription && !isChatbot && (
                                    <Suspense fallback={<PageLoader />}>
                                        <Outlet />
                                    </Suspense>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>

            <HelpModal
                isOpen={isOpenHelpModal}
                onClose={() => setIsOpenHelpModal(false)}
                openHelpModal={() => setIsOpenHelpModal(true)}
                opensuggesstion={() => setIsOpenBugModal(true)}
                isOpenBugModal={isOpenBugModal}

            />
            {
                (userid && isOpenBugModal) && <Suggestionbugmodal
                    userid={userid}
                    isOpen={isOpenBugModal}
                    onClose={() => setIsOpenBugModal(false)}
                    isBugSend={isBugSend}
                    buildNumber={buildNumber}
                    suggestionValue={suggestionValue}
                    onSuggestionChange={setSuggestionValue}
                    setisBugSend={setIsBugSend}

                />
            }
            {
                isloadingque && <Modal show={isloadingque}>
                    <Modal.Body>
                        <Loader />
                    </Modal.Body>
                </Modal>
            }

            {(youtubevideo && istutorialinfo) &&
                <TutorialModal show={youtubevideo}
                    hide={() => setYoutubevideo(false)}
                    userid={userid}
                    istutorial={istutorialinfo}
                />
            }
        </>
    );

}
export default SideBar